import { Injectable } from '@angular/core';
import { FirebaseService } from '@app/shared/services/firebase/firebase.service';

@Injectable({
  providedIn: 'root'
})
export class TypesOfHealthProfessionalsService {
  private cache: any[] = null;

  constructor(private firebase: FirebaseService) { }

  public async getHealthProfessionals(): Promise<any> {
    if (this.cache) {
      return this.cache;
    }
    try {
      const response = await this.firebase.afs.collection('types-of-health-professionals').ref.where('status', '==', 'active').get();
      this.cache = response.docs.map(item => {
        const data: any = item.data();
        const id: string = item.id;
        return { ...data, id }
      });
      return this.cache;
    } catch (error) {
      return [];
    }
  }

  public async getHealthProfessional(id: string): Promise<any> {
    return this.firebase.getHealthProfessional(id);
  }
}
